import styled from "styled-components";

export const MessageButtonsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isUser",
})<{ isUser: boolean }>`
  display: flex;
  align-self: ${props => props.isUser ? "flex-end" : "flex-start"};
`

export const ClipboardButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  transition: all 250ms ease;
  padding: 5px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #EDEBE8
  }
`

export const Message = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isUser",
})<{ isUser: boolean }>`
  position: relative;
  max-width: ${props => props.isUser ? "80%" : "100%"};
  padding: ${props => props.isUser ? "8px 12px" : "0"};
  border-radius: ${props => props.isUser ? "2px" : "0"};
  font-size: 14px;
  align-self: ${props => props.isUser ? "flex-end" : "flex-start"};
  background-color: ${props => props.isUser ? "var(--background-primary-canvas)" : "transparent"};
  color: #4a5568;
`;

export const FullWidthMessage = styled(Message)`
  width: 100%;
`;

export const SectionHeader = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;
